import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { Form, reduxForm } from 'redux-form';
import { Col, Button, Input } from 'angieslist-react-components';
import { map, extend, keys, pickBy, difference, get } from 'lodash';
import { Track } from 'angieslist-app-platform';
import { goToError } from '../../../../../profile/browser/components/utils/Utils';

import './BusinessHighlightsForm.scss';

  type State = {
    activeHighlights: Object,
  };

  type Props = {
    isDashboard: Boolean,
    businessHighlights: any,
    handleSubmit: any,
    handleClose: Function,
    allBusinessHighlights: any,
    updateBusinessHighlights: any,
    setRef: Function,
  };

class BusinessHighlightsForm extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeHighlights: {},
    };
  }

  state: State;

  componentDidMount() {
    const { businessHighlights, allBusinessHighlights, setRef } = this.props;
    const highlightDifferential = difference(businessHighlights, allBusinessHighlights);
    highlightDifferential.forEach((entry) => {
      this.setState({
        activeHighlights:
          extend(this.state.activeHighlights, { [entry.name]: true }),
      });
    });

    if (setRef) {
      setRef(this);
    }
  }

  props: Props;

  submitHighlightChange = () => {
    const highlightsToSubmit = keys(pickBy(this.state.activeHighlights));
    this.props.updateBusinessHighlights(highlightsToSubmit);
    this.props.handleClose();
  };

  handleCheckbox = (event) => {
    const highlightSelected = event.target.getAttribute('data-name');
    const highlightChecked = event.target.checked;
    this.setState({
      activeHighlights:
        extend(this.state.activeHighlights, { [highlightSelected]: highlightChecked }),
    });
  };

  render() {
    const {
      isDashboard,
      handleSubmit,
      handleClose,
      allBusinessHighlights,
    } = this.props;
    return (
      <div id="Business-Highlights-Form--Container" style={{ marginBottom: '1em' }}>
        <div className="Business-Highlights-Form-Component">
          <If condition={isDashboard}>
            <h2>Business Highlights</h2>
            <p className="text-center">These selections can be changed at any time and will appear on your business page in
              a section called &ldquo;Business Highlights&rdquo;.
            </p>
          </If>
          <Form
            onSubmit={
                handleSubmit(() => this.submitHighlightChange(), goToError())
            }
            name="BusinessHighlights"
            id="Business-Highlights-Form"
          >
            {
                  map(allBusinessHighlights, highlight => (
                    <Col xs={6} key={highlight.name}>
                      <div
                        id="Business-Highlights-Checkbox"
                        className={get(this.state.activeHighlights, `${highlight.name}`) ? 'ActiveCheckbox' : 'NonActiveCheckbox'}
                      >
                        <Col xs={3}>
                          <img
                            alt={highlight.description}
                            src={highlight.iconUrl}
                            className="Business-Highlights-Image-Wrapper"
                          />
                        </Col>
                        <Col xs={9}>
                          <Input
                            id={`BusinessHighlightsCheckbox-${highlight.name}`}
                            name={`BusinessHighlightsCheckbox-${highlight.name}`}
                            type="checkbox"
                            label={highlight.description}
                            onClick={event => this.handleCheckbox(event)}
                            data-name={highlight.name}
                            defaultChecked={get(this.state.activeHighlights, `${highlight.name}`)}
                          />
                        </Col>
                      </div>
                    </Col>
                  ))
                }
            <If condition={isDashboard}>
              <Track>
                <Button
                  style={{ marginBottom: '0.9em' }}
                  type="submit"
                  bsStyle="primary-office"
                  id="Business-Highlights--Update"
                  block
                  flat
                >
                  Update Business Highlights
                </Button>
              </Track>
              <Track>
                <Button
                  onClick={handleClose}
                  id="Business-Highlights--Close-Modal"
                  block
                  flat
                >
                    Not Now
                </Button>
              </Track>
            </If>
          </Form>
        </div>
      </div>
    );
  }
}

export default hot(module)(compose(
  reduxForm({
    form: 'BusinessHighlights',
  }),
  connect(state => ({
    formState: state.form.BusinessHighlights,
  })),
  pure,
)(BusinessHighlightsForm));



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/Card/BusinessHighlightsForm.js